import { createSlice } from '@reduxjs/toolkit'
import { addPdf, replacePdf } from 'apps/studio/store/actions/sharedActions'

// const pageMetaDefaults = {
//   pageNumber: null,
//   originalWidth: null,
//   originalHeight: null,
//   width: null,
//   height: null,
//   scaleFactor: null,
//   guidelineX: null,
//   guidelineY: null,
// }

const pdfPageMetaSlice = createSlice({
  name: 'pdfPageMeta',
  initialState: [],
  reducers: {
    addPageMeta(state, action) {
      const { pageMeta } = action.payload
      const newPageNumber = pageMeta.pageNumber
      const existingPageMetaIndex = state.findIndex(
        pdfPageMeta => pdfPageMeta.pageNumber === newPageNumber
      )

      const updatedState = state
      if (existingPageMetaIndex !== -1) {
        updatedState[existingPageMetaIndex] = pageMeta
      } else {
        updatedState.push(pageMeta)
      }

      return updatedState
    },
    updatePageMeta(state, action) {
      const { pageNumber, pageMeta } = action.payload
      const index = state.findIndex(meta => meta.pageNumber === pageNumber)
      state[index] = {
        ...state[index],
        ...pageMeta,
      }
    },
    removePageMeta(state, action) {
      const { page } = action.payload
      return state.filter(meta => meta.page !== page)
    },
  },
  extraReducers: builder => {
    builder.addCase(addPdf, () => [])
    builder.addCase(replacePdf, (state, action) => {
      const { newPageCount } = action.payload
      return state.filter(meta => meta.pageNumber <= newPageCount)
    })
  },
})

const { actions, reducer } = pdfPageMetaSlice
export const pdfPageMetaActions = actions
export const pdfPageMetaReducer = reducer
